module.exports = __webpack_public_path__ + "static/media/UserManualDM.98294714.pdf";